import { render, staticRenderFns } from "./AdminTemplates.vue?vue&type=template&id=445c6f8a&"
import script from "./AdminTemplates.vue?vue&type=script&lang=js&"
export * from "./AdminTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports